export const getCapacityString = (capacity) => {
  return typeof capacity === 'object' ? 'Object not supported' : capacity;
};
